import { updateLinksAttributes } from '../../utils/handleAttributes';

export default function majorSponsors() {
  const widgetName = 'majorSponsors';
  const widgetOpts = majorSponsorsOpts;
  const $widget = $(`#${widgetName}`);

  const wrapContainerClass = 'majorSponsors-wrap-container';

  $widget.wrap(`<div class="${wrapContainerClass}"></div>`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: ['all'],
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    textOverImage: true,
    maxItemsVisible: 10,
    itemsPerPanel: 1,
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createmajorSponsors(data.items, $widget);
      } else {
        $('.major-sponsors-container').remove();
      }
    },
  });

  function createmajorSponsors(widgetData, $widget) {
    $widget.find('.card-content').remove();
    $widget.find('.card-widget-item').each(function (x) {
      const { Title, URL } = widgetData[x];
      const $sponsor = $(this);
      updateLinksAttributes(URL, Title, $sponsor);
    });
  }
}
